import { useState } from 'react';
import React from 'react';

import { StoragePricingTable } from '@admin/components/account/storage_pricing_table';
import { PackingPackagesTable } from '@admin/components/orders/show/packing_packages_table';
import { SelectedCheck } from '@admin/components/orders/show/selected_check';
import {
  DoorToDoor__BundleEnum,
  Maybe,
  PlanKindEnum,
  PlanTypeEnum,
  Pricing,
  SubscriptionFragment,
} from '@admin/schema';

type PackageOption = {
  kind: DoorToDoor__BundleEnum;
  packageSetEntry?: { fixedCost: number } | null;
};

export const OrderPricingVisibility: React.FC<{
  currentStorageSubscription?: Maybe<SubscriptionFragment>;
  pickupServicePackageOptions: PackageOption[];
  storageLadderPricings?: Maybe<Pricing[]>;
  tags: string[];
}> = ({ currentStorageSubscription, pickupServicePackageOptions, storageLadderPricings, tags }) => {
  const [planSizesExpanded, setPlanSizesExpanded] = useState(false);
  const storageSubscriptions =
    currentStorageSubscription?.pricing.plan.type === PlanTypeEnum.StoragePlan ? currentStorageSubscription : null;
  const isCustom = storageSubscriptions?.pricing.plan.kind === PlanKindEnum.Custom;
  const showPlanTable = !!storageLadderPricings?.length;
  const currentPlanName = storageSubscriptions?.name ?? storageSubscriptions?.pricing.plan.name;

  if (!showPlanTable && pickupServicePackageOptions.length < 2) {
    return null;
  }

  return (
    <>
      {showPlanTable && (
        <>
          <p>
            <strong>Plan sizes:</strong>
            {currentPlanName && (
              <>
                {' '}
                {currentPlanName}
                <SelectedCheck selected />
              </>
            )}{' '}
            <button
              type="button"
              className="btn btn-link"
              style={{ padding: 0, verticalAlign: 'baseline' }}
              aria-expanded={planSizesExpanded}
              onClick={() => setPlanSizesExpanded((expanded) => !expanded)}
            >
              {planSizesExpanded ? 'Hide plan sizes' : 'Show plan sizes'}
            </button>
          </p>
          {planSizesExpanded && (
            <StoragePricingTable
              isCustom={!!isCustom}
              selectedSubscription={storageSubscriptions}
              storageLadderPricings={storageLadderPricings}
            />
          )}
        </>
      )}
      <PackingPackagesTable options={pickupServicePackageOptions} tags={tags} />
    </>
  );
};
